import React, { useCallback, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Imposter } from '@hub/imposter';
import { Cover } from '@hub/cover';
import { jsx as _jsx } from "react/jsx-runtime";
const RouteChangeIndicator = function RouteChangeIndicator(_ref) {
  let {
    fallback: Fallback,
    children
  } = _ref;
  const router = useRouter();
  const {
    0: isRouteChanging,
    1: setRouteChanging
  } = useState(false);
  const routeChangeStart = useCallback((_url, _ref2) => {
    let {
      shallow
    } = _ref2;
    if (!shallow) {
      setRouteChanging(true);
    }
  }, [setRouteChanging]);
  const routeChangeCompleteOrError = useCallback(() => {
    setRouteChanging(false);
  }, [setRouteChanging]);
  useEffect(() => {
    router.events.on('routeChangeStart', routeChangeStart);
    router.events.on('routeChangeComplete', routeChangeCompleteOrError);
    router.events.on('routeChangeError', routeChangeCompleteOrError);
    return () => {
      router.events.off('routeChangeStart', routeChangeStart);
      router.events.off('routeChangeComplete', routeChangeCompleteOrError);
      router.events.off('routeChangeError', routeChangeCompleteOrError);
    };
  }, [router, routeChangeStart, routeChangeCompleteOrError]);
  return /*#__PURE__*/_jsx(Imposter, {
    impose: isRouteChanging ? /*#__PURE__*/_jsx(Cover, {
      sx: {
        zIndex: 'popover'
      },
      backgroundColor: "white",
      "data-id": "route-change-indicator_index_RouteChangeIndicator_Cover",
      children: /*#__PURE__*/_jsx(Fallback, {
        "data-id": "route-change-indicator_index_RouteChangeIndicator_Cover_Fallback"
      })
    }) : undefined,
    sx: {
      height: '100%'
    },
    "data-id": "route-change-indicator_index_RouteChangeIndicator_Imposter",
    children: children
  });
};
export default RouteChangeIndicator;